export default "__VITE_ASSET__BsvJNFtv__"